/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {URLSearchParams, HttpModule} from '@angular/http';
import {NgModule} from '@angular/core';
import {TabViewModule, PanelModule, DataTableModule, SharedModule,PaginatorModule,DropdownModule,InputTextModule,CalendarModule} from 'primeng/primeng';
import {SelectItem} from 'primeng/primeng';
import {MamAdminService} from '../../service/mam_service.component';
import {AgentLog} from '../../model/agentlog';
import {FormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {BrowserModule} from "@angular/platform-browser";
import {TranslateServiceForm} from "../../translate/translate.service";
import {SearchDropBoxModule} from "../../component/search_dropbox.component";
import {Logger, Options, Level } from "angular2-logger/core";
import {MainPipeMoudle} from "../../pipe/main.pipe";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe";
import {OTPHistory} from '../../model/OTPHistory';
import * as glob from "../../service/global_url";

@Component({
  selector: 'otp_history',
  // host : {'(document:keydown)' : 'onKeyUp($event)'},
  templateUrl: 'otp_history.html'
})
export class OTPHistoryComponent implements OnInit {
  // @HostListener('window:keyup', ['$event'])
  // onKeyup(event: any) {
  //   console.log('keyup..', event);
  // }
  otp_list: OTPHistory[] = [];
  page: number;
  max: number;
  
  search: string;
  field: string;
  start: string;
  end: string;
  searchIDs: SelectItem[];
  selectedSearchID: string;
  searchText: string;

  totalRecord: number;
  sDate: string;
  eDate: string;

  dateIsTrue : boolean = true;
  searchIsTrue : boolean = false;
  pageMax : number=10;
  date : Date= new Date();
  datePipe : any = new DatePipe("en");

  private translate:TranslateServiceForm;

  searchId : string;

  searchTextDropBox : SelectItem[];
  searchTextIsDropBox : boolean;
  searchTextIsUse : boolean;
  excelIsTrue : boolean = true;

  log_type_items : SelectItem[];

  constructor(private service: MamAdminService, private _translate: TranslateServiceForm, private logger : Logger) {
    this.translate = _translate;
    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 'all'});
    this.searchIDs.push({label: this.translate.instant('UserName'), value: 'username'});
    this.searchIDs.push({label: this.translate.instant('AUDIT_UserService_membernum'), value: 'memberNumber'});
    this.searchIDs.push({label: this.translate.instant('AUDIT_ProductDeviceService_status'), value: 'status'});

    this.log_type_items = [];
    this.log_type_items.push({label: '---------------', value: 'all'});
    this.log_type_items.push({label: this.translate.instant('AL_TAToken_ISSUE'), value: 'PUBLISH'});
    this.log_type_items.push({label: this.translate.instant('token_authenticate_success'), value: 'AUTHENTICATED'});
    this.log_type_items.push({label: this.translate.instant('AL_TAToken_Expired'), value: 'EXPIRE'});
    

  }

  ngOnInit() {
    
    this.page = 1;
    this.max = 10;
    let nDate = new Date();
    nDate.setDate(nDate.getDate()-15);
    this.sDate = this.datePipe.transform(nDate, 'yyyy-MM-dd')
    this.eDate = this.datePipe.transform(this.date, 'yyyy-MM-dd')
    this.getOTPHistorySearch(0,10, "", "", this.sDate, this.eDate);

  }


  excelExport(event){
    this.logger.debug(event);
    this.logger.debug(this.sDate);
    this.logger.debug(this.eDate);
    if(!this.sDate || !this.eDate) {
      alert(this.translate.instant('MESSAGE_Search_And_Out'));
      return;
    }
    
    var url = this.service.getUrl() + "/mgr/log/smsAuth/export";
    if(!this.selectedSearchID || this.searchId == "all") {
      url = url + "?start=" + this.sDate + "&end=" + this.eDate;
    } else{
      url = url + "?start=" + this.sDate + "&end=" + this.eDate +
      "&search_text=" + this.searchText + "&search_field=" + this.selectedSearchID;
    }
    window.open(url);
  }

  // onKeyUp(event) {
  //   console.log("agent log onKeyDown :" , event);
  // }

  getSearchModel(event) {
    console.log("event -> :" , event);
    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.sDate = event.sDate;
    this.eDate = event.eDate;
    this.selectedSearchID = event.searchId;

    console.log("selectedSearchID :" , this.selectedSearchID);

    if(!this.sDate || !this.eDate ) {
      alert(this.translate.instant('MESSAGE_SearchDate_Require'));
      return;
    }

    if(this.eDate < this.sDate ) {
      alert(this.translate.instant('MESSAGE_LastDate_Less_StartDate'));
      return;
    }

    if(this.selectedSearchID == 'name' && !this.searchText) {
      alert(this.translate.instant('MESSAGE_Select_LogType'));
      return;
    }
    this.getOTPHistorySearch(0, this.pageMax, this.searchText, this.selectedSearchID, this.sDate, this.eDate);
  }

  paginate(event) {
    this.pageMax = event.rows;
    if (this.searchIsTrue) {
      this.getOTPHistorySearch(event.page, event.rows ,this.searchText, this.selectedSearchID, this.sDate , this.eDate);
    } else {
      this.getOTPHistorySearch(event.page, event.rows, '', '', this.sDate, this.eDate);
    }
  }

  searchTextChange(data) {
    this.logger.debug("data => ", data);
    if(data == "status") {
      this.searchTextIsDropBox = true;
      this.searchTextDropBox = this.log_type_items;
      this.searchTextIsUse = false;
    } else if(data == 'all' || !data)  {
      this.searchTextIsDropBox = false;
      this.searchTextIsUse = false;
    } else {
      this.searchTextIsDropBox = false;
      this.searchTextIsUse = true;
    }

  }

  getOTPHistorySearch(page: number, max: number, search: string, field: string, start: string, end: string): void {
    this.service.getOTPHisotrySearch(page, max, search, field, start, end).subscribe(
      value => {
        this.otp_list = value.content;
        this.totalRecord = value.totalElements;
        this.logger.debug("-- agent log list : ", value);
      },
      error => {this.logger.error("-- error : " + error);},
      () => { })
  }

  keyup()  {
    alert("asdasdasd");
  }

}
@NgModule({
  imports: [PanelModule, TabViewModule, DataTableModule, SharedModule, CommonModule,PaginatorModule,DropdownModule,InputTextModule,BrowserModule,HttpModule, RouterModule,FormsModule,CalendarModule, SearchDropBoxModule, MainPipeMoudle, TranslatePipeMoudle],
  exports: [OTPHistoryComponent],
  declarations: [OTPHistoryComponent],
  providers: [],
})
export class OTPHistoryModule {
}



// WEBPACK FOOTER //
// ./src/app/page/log/otp_history.ts